import { render, staticRenderFns } from "./PainelTriagem.vue?vue&type=template&id=1567957d&"
import script from "./PainelTriagem.vue?vue&type=script&lang=js&"
export * from "./PainelTriagem.vue?vue&type=script&lang=js&"
import style0 from "./PainelTriagem.vue?vue&type=style&index=0&id=1567957d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports